import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'

export async function getVersions(brand, model, year, queryParamString){
    const queryString = queryParamString || ''
    let results = ''
    try {
        results = await axios.get(`${DATAMASTER_ENDPOINT}/brands/${brand}/models/${model}/years/${year}/versions${queryString}`)
    } catch (error) {
        results = error.message
    }
    return results
}